import { render } from "./HighlightIt.vue?vue&type=template&id=a506c868&scoped=true"
import script from "./HighlightIt.vue?vue&type=script&lang=js"
export * from "./HighlightIt.vue?vue&type=script&lang=js"

import "./HighlightIt.vue?vue&type=style&index=0&id=a506c868&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a506c868"]])

export default __exports__